class Controller {
  constructor() {
    this.reportResourceParams = { isCityRequired: false };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/report/report.controller.js